import { Grid } from "@mui/material";
import { useAppSelector } from "app/hooks";
import { FormSection } from "components/FormControls/FormSection";
import { SelectInput } from "components/FormControls/Select/Select";
import { TextInput } from "components/FormControls/TextInput";
import { useMessage } from "hooks/intl";
import { memo } from "react";
import { getCountries } from "reduxState/settings/settings";
import { useStyles } from "./Transaction.styles";

interface Props {
  isFormDataReady: boolean;
  editMode?: boolean;
}

export const MemberDetails = memo(({ isFormDataReady, editMode }: Props) => {
  const classes = useStyles();
  const { message } = useMessage();
  const countriesList = useAppSelector(getCountries);

  return (
    <FormSection
      isLoading={!isFormDataReady}
      title={message({ id: "memberDetails" })}
    >
      <Grid container spacing={10}>
        <Grid xs={12} md={4} lg={3} item>
          <TextInput
            className={classes.fullWidth}
            label={message({ id: "fullName" })}
            name="customerData.name"
            data-test-id="full-name-input"
            data-hj-suppress
          />
        </Grid>
        <Grid xs={12} md={4} lg={3} item>
          <TextInput
            className={classes.fullWidth}
            label={message({ id: "email" })}
            name="customerData.email"
            type="mail"
            data-test-id="email-input"
            data-hj-suppress
          />
        </Grid>
        <Grid xs={12} md={4} lg={3} item>
          <TextInput
            className={classes.fullWidth}
            label={message({ id: "phoneNumber" })}
            name="customerData.phone"
            type="phone"
            data-test-id="phone-number-input"
            data-hj-suppress
          />
        </Grid>
        <Grid xs={12} md={4} lg={3} item>
          <TextInput
            className={classes.fullWidth}
            label={message({ id: "loyaltyCardNumber" })}
            name="customerData.loyaltyCardNumber"
            data-test-id="loyalty-card-number-input"
            data-hj-suppress
          />
        </Grid>
        {!editMode && (
          <Grid xs={12} md={4} lg={3} item>
            <TextInput
              className={classes.fullWidth}
              label={message({ id: "memberID" })}
              name="customerData.customerId"
              data-test-id="member-id-input"
              data-hj-suppress
            />
          </Grid>
        )}
        <Grid xs={12} md={4} lg={3} item>
          <TextInput
            className={classes.fullWidth}
            label={message({ id: "taxID" })}
            name="customerData.nip"
            data-test-id="tax-id-input"
            data-hj-suppress
          />
        </Grid>
        <Grid xs={12} md={4} lg={3} item>
          <TextInput
            className={classes.fullWidth}
            label={message({ id: "street" })}
            name="customerData.address.street"
            data-test-id="street-input"
            data-hj-suppress
          />
        </Grid>
        <Grid xs={12} md={4} lg={3} item>
          <TextInput
            className={classes.fullWidth}
            label={message({ id: "buildingName" })}
            name="customerData.address.address1"
            data-test-id="building-name-input"
            data-hj-suppress
          />
        </Grid>
        <Grid xs={12} md={4} lg={3} item>
          <TextInput
            className={classes.fullWidth}
            label={message({ id: "flatUnitName" })}
            name="customerData.address.address2"
            data-test-id="flat-unit-name-input"
            data-hj-suppress
          />
        </Grid>
        <Grid xs={12} md={4} lg={3} item>
          <TextInput
            className={classes.fullWidth}
            label={message({ id: "postalCode" })}
            name="customerData.address.postal"
            data-test-id="postal-code-input"
            data-hj-suppress
          />
        </Grid>
        <Grid xs={12} md={4} lg={3} item>
          <TextInput
            className={classes.fullWidth}
            label={message({ id: "city" })}
            name="customerData.address.city"
            data-test-id="city-input"
            data-hj-suppress
          />
        </Grid>
        <Grid xs={12} md={4} lg={3} item>
          <TextInput
            className={classes.fullWidth}
            label={message({ id: "state" })}
            name="customerData.address.province"
            data-test-id="state-input"
            data-hj-suppress
          />
        </Grid>
        <Grid xs={12} md={4} lg={3} item>
          <SelectInput
            className={classes.fullWidth}
            items={countriesList?.map((country) => {
              return {
                id: country?.code,
                label: country?.name,
              };
            })}
            label={message({ id: "country" })}
            name="customerData.address.country"
            data-test-id="country-select-input"
            data-hj-suppress
          />
        </Grid>
      </Grid>
    </FormSection>
  );
});
